import apiClient from '@src/api/clients';

const BASE_URL = 'dashboard/feed-health/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

// Staff feed & backend-data health board.
// params: {
//   problems_only: bool,     // only rows whose health is a problem
//   include_archived: bool,  // also list archived mappings
//   client_id / parent_company: id,  // optional scope narrowing
//   fresh: bool,             // bypass the short server cache (use after a
//                            //   mutating action so the caller sees its change)
// }
export const fetchFeedHealth = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

// Run history for one mapping: { runs: [{status, rows, source_file, ...}] }.
export const fetchFeedRuns = ({ type, id, limit = 10 }) =>
  apiClient.request({
    url: `${BASE_URL}runs/`,
    method: 'GET',
    payload: cleanParams({ type, id, limit }),
  });

// Flow-through panel: latest run -> backend rows -> summary refresh -> dashboards.
export const fetchFeedPipeline = ({ type, id }) =>
  apiClient.request({
    url: `${BASE_URL}pipeline/`,
    method: 'GET',
    payload: cleanParams({ type, id }),
  });

// AI troubleshooting for one feed (cached 24h server-side; force regenerates).
export const diagnoseFeed = ({ type, id, force = false }) =>
  apiClient.request({
    url: `${BASE_URL}diagnose/`,
    method: 'POST',
    payload: { type, id, force },
  });

// Download an archived source file (ClientProcessedCSV) as a blob.
export const downloadSourceFile = (fileId) =>
  apiClient
    .request({
      url: `dashboard/client-processed-csv/${fileId}/download/`,
      method: 'GET',
      options: { responseType: 'blob' },
    })
    .then((response) => response.data);

export default {
  fetchFeedHealth,
  fetchFeedRuns,
  fetchFeedPipeline,
  diagnoseFeed,
  downloadSourceFile,
};
